import { LazyLoad } from '@petconsole/pure-fe-mui';

const Profile = LazyLoad(() => import('./ProfileApp'));

export { Profile };
